import React, { useEffect, useState } from "react";
import { Btn } from "../../../../AbstractElements";
import CustomInput from "../../../../Component/BasicComponents/CustomInput";
import ReusableCheckBox from "../../../../Component/BasicComponents/ReusableCheckbox";
import { useAddExpenseHead, useAllPurpose, useGetPolicyKeys, useSingleExpense, useUpdateExpHead } from "../hooks/useExpense";
import { mapExpenseData } from "../formDataHelper";
import DualListBox from "../../../../Component/BasicComponents/DualListBox";
import ReusableDropdown from "../../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useBudgetsData } from "../../Grade Master/hooks/useGradeMaster";

interface PurposeFormProps {
  handleClose: () => void;
  expenseId?: number | null;
  mode: "view" | "edit" | "add";
  trips: any
}

interface formData {
  title: string;
  sortOrder: string;
  policyKey: string;
  metroClassA: string;
  metroClassB: string;
  others: string;
  trips: string;
  purposeRoles: number[];
  checkedItems: { label: string; value: string; checked: boolean }[];
}

type ExpenseApiResponse = {
  Bgid: number;
  GroupName: string;
};
const ExpenseHeadModal: React.FC<PurposeFormProps> = ({handleClose,expenseId, mode,trips,}) => {

  const ExpenseID: any = expenseId;
  const { data, isLoading, isSuccess } = useSingleExpense({ id: ExpenseID,enable: true,});
  const { data: result } = useGetPolicyKeys({ enable: true })
  const { data: allPurpose } = useAllPurpose({ enable: true });
  const { mutate } = useAddExpenseHead()
  const { mutate: updateExpHead } = useUpdateExpHead()


  const formattedMetroClassAData = result?.data.map((item: string) => ({
    id: item,
    label: item
  }))
  const formateedTrips = trips?.map((item: string, index: any) => ({
    id: index,
    label: item
  }))
 
   const [btnCount,setbtnCount] = useState<number>(0);

  useEffect(() => {
    if ((mode === "edit" || mode === "view") && ExpenseID && isSuccess) {
      setFormData(mapExpenseData(data));

    }
    setbtnCount(0);
  }, [mode, isSuccess, data]);


  const checkboxData = [
    { label: "Mandatory", value: "isMandatory", checked: 0 },
    { label: "Is prefilled", value: "isPrefilled", checked: 0 },
    { label: "Is rate applied", value: "Israteapplied", checked: 0 },
    { label: "Once per month", value: "permonth", checked: false },
    { label: "Check City", value: "checkCity", checked: 0 },
    { label: "Rate", value: "rate", checked: 0 },
    {
      label: "Attachment Required",
      value: "attachmentRequired",
      checked: false,
    },
  ];

  const initialFormData = {
    title: "",
    sortOrder: "",
    policyKey: "",
    metroClassA: "",
    metroClassB: "",
    others: "",
    trips: "",

    purposeRoles: [],
    checkedItems: checkboxData.map(item => ({
      ...item,
      checked: false, // Ensure all items have a checked field
    })),
  };

  const [formData, setFormData] = useState<formData>(initialFormData);
  // Handle dropdown selection
  const handleDropdownSelect = (field: string, value: string | number) => {
    setFormData((prevState) => ({
      ...prevState,
      [field]: value, // Directly assign the selected value
    }));
  };

  const handleInputChange = (fieldName: keyof formData,value: string | string[]) => {
    setFormData((prestate) => ({
      ...prestate,
      [fieldName]: value,
    }));
  };

  // console.log('purpseRole',formData.purposeRoles);

  const handleSubmit = (data: any) => {

    // Default values for missing keys
    const defaultValues = {
      title: "",
      sortOrder: "",
      defaultPolicykey: "", // policyKey se aayegi
      checkCity: 0,
      policykeya: "", // metroClassA se aayegi
      policykeyb: "", // metroClassB se aayegi
      policykeyc: "", // others se aayegi
      trips: "",
      budgets: [],
      isMandatory: 0,
      isPrefilled: 0,
      israteapplied: 0,
      rate: 0,
      permonth: false,
      isdaily: 0,
      mode: "submit",
      nonreimbursable: 0,
      commentreq: false,
      attachmentRequired: false,
    };

    // Merge user data with default values
    const formattedData = { ...defaultValues, ...data };

    // Map policy keys
    formattedData.defaultPolicykey = data.policyKey || "";
    formattedData.policykeya = data.metroClassA || "";
    formattedData.policykeyb = data.metroClassB || "";
    formattedData.policykeyc = data.others || "";



    // Remove unnecessary keys
    delete formattedData.policyKey;
    delete formattedData.metroClassA;
    delete formattedData.metroClassB;
    delete formattedData.others;

    // Map trips
    formattedData.trips = data.trips || "";

    // Map budgets from purposeRoles
    formattedData.budgets = data.purposeRoles || [];
    delete formattedData.purposeRoles;

    // Convert checkedItems array to key-value format
    if (data.checkedItems) {
      data.checkedItems.forEach((item: any) => {

        formattedData[item.value] = item.checked;
      });
      delete formattedData.checkedItems;
    }

    if (mode === 'edit') {
     setbtnCount(1);
      updateExpHead({ ...formattedData, expenseId: ExpenseID }, {
        onSuccess: () => {
          handleClose();
          // setEditLeaveConfigurationModal("");
          // setSelectedRowData(null);
        },
      })

    }
    else {
      setbtnCount(1);
      mutate(formattedData, {
        onSuccess: () => {
          handleClose();
          // setEditLeaveConfigurationModal("");
          // setSelectedRowData(null);
        },
      })

    }

  }

  const {data: budgetData,} = useBudgetsData({ enable: true });

  const ExpenseRequestData = budgetData?.data?.map(
      (item: ExpenseApiResponse,) => ({
      Bgid: item?.Bgid,
      GroupName: item?.GroupName,
    })
  )

  const handleCheckedChange = (selectedValues: string[]) => {
    setFormData((prevState: any) => ({
      ...prevState,
      checkedItems: prevState.checkedItems.map((item: any) => ({
        ...item,
        checked: selectedValues.includes(item.value) ? 1 : 0, // `false` remains `false`, `true` becomes `1`
      })),
    }));
  };

  // console.log('count---------------------------',btnCount);

  return (
    <div >
      <form onSubmit={(e)=>{e.preventDefault(); handleSubmit(formData)}}>
      <div>
        {/* Input Fields */}
        <div className="row mb-0 col-sm-12">

          <div className="col-sm-3">
            <CustomInput
              asterisk
              disabled={mode === "view" ? true : false}
              label="Title"
              required={true}
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
                padding: "10px",
                fontSize: "14px",
              }}
              value={formData.title}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInputChange("title", e.target.value)
              }
            />
          </div>

          <div className="col-sm-3">
            <CustomInput
              required={true}
              type={'number'}
              disabled={mode === "view" ? true : false}
              label="Sort Order"
              asterisk
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
                padding: "10px",
                fontSize: "14px",
              }}
              value={formData.sortOrder}
              
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInputChange("sortOrder", e.target.value)
              }
            />
          </div>

          <div className="col-sm-3">
            <CustomInput
              disabled={mode === "view" ? true : false}
              label="Policy Key"
              style={{
               border: "1px solid #e0e0e0",
                borderRadius: "4px",
                padding: "10px",
                fontSize: "14px",
              }}
              value={formData.policyKey}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleInputChange("policyKey", e.target.value)
              }
            />
          </div>

          <div className="col-sm-3">
            <ReusableDropdown
             isDisabled={mode === "view" ? true : false}
              options={formattedMetroClassAData || []}
              value={formData.metroClassA}
              onChange={(value: any) => {
                handleDropdownSelect("metroClassA", value);
              }}
              DropdownHeading="Metro Class(A)" />

          </div>

        </div>

        {/* Dropdowns */}
        <div className="row mb-0 col-sm-12">

          <div className="col-sm-4">
            <ReusableDropdown
             isDisabled={mode === "view" ? true : false}
              options={formattedMetroClassAData || []}
              value={formData.metroClassB}
              onChange={(value: any) => {
                handleDropdownSelect("metroClassB", value);
              }}
              DropdownHeading="Metro Class(B)"
            />
          </div>

          <div className="col-sm-4">
      
            <ReusableDropdown      
             isDisabled={mode === "view" ? true : false}
              options={formattedMetroClassAData || []}
              value={formData.others}
              onChange={(value: any) => {
                handleDropdownSelect("others", value);
              }}
              DropdownHeading="Others"
            />
          </div>

          <div className="col-sm-4">
            <ReusableDropdown
             isDisabled={mode === "view" ? true : false}
              options={formateedTrips || []}
              value={formData.trips}
              onChange={(id: any,) => {
                handleDropdownSelect("trips", id);
              }}
              DropdownHeading="Trips" />
          </div>

        </div>

        <DualListBox
        disabled={mode ==='view'?true:false}
          DualListLabel="Purpose"
          leftOptions={
            (true &&
              ExpenseRequestData?.map((item: any) => {
                return {
                  id: item.Bgid,
                  label: item.GroupName,
                };
              })) || []
          }
          onSelectionChange={(selected: any) => {
            setFormData({
              ...formData,
              ["purposeRoles"]: selected?.map((item: any) => item?.id) || [],
            });
          }}
          value={mode ==='edit' || mode ==='view'?formData.purposeRoles:formData.purposeRoles}/>

        {/* Checkboxes */}
        <div style={{ marginLeft: "-12px" }}>
          <ReusableCheckBox
          disabled={mode ==='view'?true:false}
            data={!isLoading ? formData.checkedItems : []}
            onCheckedChange={handleCheckedChange}
          />
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-start gap-2">
          <Btn
            style={{ backgroundColor: "#43B9B2", color: "white" }}
            type="submit"
            disabled={mode ==='view' || btnCount == 1}
>               
            Submit
          </Btn>

          <Btn
            type="button"
            onClick={handleClose}
            style={{ backgroundColor: "#F9FAFC", color: "#000" }}>
            Cancel
          </Btn>
        </div>
      </div>
      </form>
    </div>
  );
};

export default ExpenseHeadModal;
